/** Shared element-type suffixes — the last segment of every data-testid value */
export const Element = {
  ACCORDION: 'accordion',
  BADGE: 'badge',
  BAR: 'bar',
  BUTTON: 'button',
  CHECKBOX: 'checkbox',
  CONTAINER: 'container',
  DRAWER: 'drawer',
  DROPDOWN: 'dropdown',
  ERROR: 'error',
  FLYOUT: 'flyout',
  ICON: 'icon',
  INPUT: 'input',
  LABEL: 'label',
  LINK: 'link',
  LOADER: 'loader',
  MODAL: 'modal',
  PILL: 'pill',
  ROW: 'row',
  SELECT: 'select',
  SUCCESS: 'success',
  SWITCH: 'switch',
  TAB: 'tab',
  TABLE: 'table',
  TITLE: 'title',
  TOGGLE: 'toggle',
  TOOLTIP: 'tooltip'
} as const

/** Shared page/section prefixes — the first segment of every data-testid value */
export const Page = {
  ACCOUNT_SETUP_HUB: 'account-setup-hub',
  AI_COACH: 'ai-coach',
  ATTACHMENTS: 'attachments',
  AUTHORIZATION: 'authorization',
  AUTOMATION: 'automation',
  BLOCKS: 'blocks',
  BRAND_OVERRIDE: 'brand-override',
  CALLBACK: 'callback',
  CONTACT_SUBMISSIONS: 'contact-submissions',
  CONTACT_US: 'contact-us',
  CSV_REPORTS: 'csv-reports',
  CUSTOMER_PROFILE: 'customer-profile',
  DEFAULT_LINKS: 'default-links',
  EMAIL_CONFIGURATION: 'email-configuration',
  EMAIL_TEMPLATES: 'email-templates',
  ENHANCED_PROFILE: 'enhanced-profile',
  FORM_SUBMISSIONS: 'form-submissions',
  GLOBAL_BRAND: 'global-brand',
  GUEST_INBOX: 'guest-inbox',
  INCIDENTS: 'incidents',
  INTEGRATIONS: 'integrations',
  ITEM_LEVEL_FEEDBACK: 'item-level-feedback',
  LOCATION_PROPERTIES: 'location-properties',
  LOCATIONS: 'locations',
  MANAGE_GROUPS: 'manage-groups',
  MANAGE_LOCATIONS: 'manage-locations',
  MANAGEMENT_TEAM: 'management-team',
  METABASE: 'metabase',
  NOT_FOUND: 'not-found',
  OBJECTIVES: 'objectives',
  ONLINE_REVIEWS: 'online-reviews',
  PENDING_APPROVAL: 'pending-approval',
  ACCOUNT_DEACTIVATED: 'account-deactivated',
  PHOTO_WALL: 'photo-wall',
  PRIVACY_DATA_REQUESTS: 'privacy-data-requests',
  PRODUCT_CATALOG: 'product-catalog',
  PROFILE_PREFERENCES: 'profile-preferences',
  QUESTIONNAIRES: 'questionnaires',
  RATING_TRENDS: 'rating-trends',
  REPORTING: 'reporting',
  RESPONSES: 'responses',
  REWARDS: 'rewards',
  SMS_CONFIG: 'sms-config',
  SQUARE_OAUTH_REDIRECT: 'square-oauth-redirect',
  SURVEY_CONFIGURATION: 'survey-configuration',
  SNAPSHOTS: 'snapshots',
  ITEM_LINKING: 'item-linking',
  IDENTITY_ACCESS: 'identity-access',
  BRAND_VOICE: 'brand-voice',
  KNOWLEDGE_BASE: 'knowledge-base',
  QUESTIONNAIRE_RESULTS: 'questionnaire-results',
  TAGS: 'tags',
  ADMIN_PROFILE: 'admin-profile',
  PROFILE_ACCOUNT: 'profile-account',
  API_CLIENTS: 'api-clients',
  LINK_OVERRIDES: 'link-overrides',
  LOCATION_STAFF: 'location-staff',
  SHIFTS: 'shifts',
  SIDEBAR: 'sidebar',
  UNAUTHORIZED: 'unauthorized'
} as const
